import Enums from './enum';
import { timeAgo, durationBetweenInMilliseconds } from './dateUtilities';

const getDeviceStatusDetails = (pulse, warningThreshold, dangerThreshold) => {
    const minsAgo = Math.floor(durationBetweenInMilliseconds(pulse, Date.now()) / 60000);
    const formattedElapsedTime = timeAgo(pulse);
    if (minsAgo >= dangerThreshold) {
        return {
            status: 1,
            statusPillButton:
                <span className="badge badge rounded-pill badge-danger">
                    {formattedElapsedTime} <i className="fas fa-times"></i>
                </span>
        }

    } else if (minsAgo >= warningThreshold) {
        return {
            status: 2,
            statusPillButton:
                <span className="badge badge rounded-pill badge-warning">
                    {formattedElapsedTime} <i class="fas fa-exclamation"></i>
                </span>
        }
    } else if (minsAgo < warningThreshold) {
        return {
            status: 3,
            statusPillButton:
                <span className="badge badge rounded-pill badge-success">
                    {formattedElapsedTime} <i className="fas fa-check"></i>
                </span>
        }
    }
}


export const getDeviceStatus = (device, deviceType, warningThreshold, dangerThreshold) => {
    if (!warningThreshold && !dangerThreshold) {
        warningThreshold = 30;
        dangerThreshold = 60;
    }

    let deviceStatusReturnUtils = {
        status: 0,
        statusPillButton:
            <span className="badge badge rounded-pill badge-secondary">
                Unknown <i className="fas fa-question"></i>
            </span>
    }
    
    let pulse;

    switch (deviceType) {
        case Enums.DeviceType[0]:
            // camera
            pulse = device.lastHeartbeat;
            if (pulse !== null) {
                deviceStatusReturnUtils = getDeviceStatusDetails(pulse, warningThreshold, dangerThreshold);
            }
            break;
        case Enums.DeviceType[1]:
            // kiosk
            pulse = device.lastPing;
            if (pulse !== null) {
                deviceStatusReturnUtils = getDeviceStatusDetails(pulse, warningThreshold, dangerThreshold);
            }
            break;
        default:
            break;
    }
    return deviceStatusReturnUtils;
}